import { Action, createReducer, on } from '@ngrx/store';
import * as AchEnrollmentActions from '../actions/ach-enrollment.actions';
import { AchEnrollmentState, initialState } from '../state/ach-enrollment.state';

export const achEnrollmentReducer = createReducer(
    initialState,
    on(AchEnrollmentActions.createAchEnrollment, (state, { achEnrollment }) => ({
        ...state,
        achEnrollment,
    })),
    on(AchEnrollmentActions.createAchEnrollmentFailure, () => initialState),
    on(AchEnrollmentActions.successPageExited, () => initialState)
);

export function reducer(state: AchEnrollmentState | undefined, action: Action): AchEnrollmentState {
    return achEnrollmentReducer(state, action);
}
